import { create } from "zustand";
import { Button, Card, Space, Modal, notification } from "antd";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import DataListStore from "store/DataListStore";
import ListViewV2 from "../DataListV2";
import { useRef, useState } from "react";
import {
  ProForm,
  ProFormText,
  ProFormTextArea,
} from "@ant-design/pro-components";
import { RequestProsesResi } from "services/datalist/datalist-api";

const resiTrackingStore = create(DataListStore);

function ProsesResi(props) {
  const formRef = useRef();
  const formUploadRef = useRef();

  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalUploadOpen, setModalUploadOpen] = useState(false);
  const [resiValue, setResiValue] = useState("");
  const [listResi, setListResi] = useState([]);

  const [reloader, setReloader] = useState(false);

  const divRef = useRef();

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const openModalUpload = () => {
    setModalUploadOpen(true);
  };

  const closeModalUpload = () => {
    setModalUploadOpen(false);
  };

  const onModalOK = () => {
    formRef.current.submit();
    closeModal();
  };

  const onModalUploadOK = () => {
    formUploadRef.current.submit();
    closeModalUpload();
  };

  return (
    <Card
      title={
        <strong>
          <h1>Proses Resi</h1>
        </strong>
      }
    >
      <Space
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Space>
          <Button type="primary" onClick={openModal} size="large">
            <Space>
              <PlusOutlined /> Proses Scan Resi
            </Space>
          </Button>
          <Button onClick={openModalUpload} size="large">
            <Space>
              <UploadOutlined /> Input Resi
            </Space>
          </Button>
        </Space>
        <p>Proses scan/Input resi yang dicetak</p>
      </Space>

      <Modal
        title="Proses List Resi"
        open={isModalUploadOpen}
        onOk={onModalUploadOK}
        onCancel={closeModalUpload}
      >
        <ProForm
          autoFocusFirstInput
          formRef={formUploadRef}
          submitter={false}
          onFinish={async (val) => {
            let arr = val.resi.split("\n");
            if (arr.length > 0) {
              await RequestProsesResi({
                mode: "Resi",
                resi: arr,
                keterangan: "",
              });

              setReloader(!reloader);

              notification.success({
                message: "Success",
              });
            }
            formUploadRef.current.resetFields();
          }}
        >
          <ProFormTextArea
            name={"resi"}
            label={"Enter/Scan No Resi"}
            placeholder={"Pisahkan Resi dengan Enter"}
            fieldProps={{ rows: 12 }}
          />
        </ProForm>
      </Modal>

      <Modal
        title="Scan Resi"
        open={isModalOpen}
        onOk={onModalOK}
        onCancel={closeModal}
      >
        <ProForm
          autoFocusFirstInput
          formRef={formRef}
          submitter={false}
          onFinish={async (val) => {
            console.log(val);
            formRef.current.resetFields();
            if (listResi.length > 0) {
              await RequestProsesResi({
                mode: "Resi",
                resi: listResi,
                keterangan: "",
              });
              setReloader(!reloader);

              notification.success({
                message: "Success",
              });
            }
            setListResi([]);
            setResiValue("");
          }}
          onKeyDown={(e) => {
            let noResi = formRef.current.getFieldValue("no");
            if (e.key === "Enter" && noResi) {
              let newList = listResi;
              newList.push(noResi);
              setListResi(newList);
              setResiValue(newList.join("\n"));
              formRef.current.setFieldValue("no", "");
              divRef.current.scrollTop = divRef.current.scrollHeight - 10;
            }
          }}
        >
          <ProFormText name={"no"} label="Masukan No. Resi" />
          <p>
            List Scan Resi : <strong>Total {listResi.length}</strong>
          </p>
          <div
            ref={divRef}
            style={{
              minHeight: "180px",
              maxHeight: "400px",
              overflow: "scroll",
            }}
          >
            <ProFormTextArea
              name={"listResi"}
              readonly={true}
              fieldProps={{ value: resiValue, rows: 8 }}
            />
          </div>
        </ProForm>
      </Modal>

      <br />
      <ListViewV2
        viewId="resitracking"
        store={resiTrackingStore}
        hideTitle={true}
        reloader={reloader}
      />
    </Card>
  );
}

export default ProsesResi;
